<template>
  <div class="teacherDetail app-content">
    <div class="teacherHead">
      <div class="headBox">
        <div class="head-img">
          <img :src="teacherData.headimg" alt="">
        </div>
        <div class="headContent">
          <div class="nameBox">
            <h3>{{teacherData.name}}</h3>
            <el-rate
              v-model="teacherData.score"
              disabled>
            </el-rate>
          </div>
          <div class="parameter">
            <div>课程： <span class="blueColor">{{teacherData.CurriculumEntitys ? teacherData.CurriculumEntitys.length : ''}}</span></div>
          </div>
          <div class="synopsis">
            简介：{{teacherData.introduce}}
          </div>
        </div>
      </div>
    </div>
    <div class="teacherContent">
      <h2 class="titleBox">- 开设课程 -</h2>
      <cur-list :curriculumData="teacherData.CurriculumEntitys"></cur-list>
    </div>
  </div>
</template>

<script>
import curList from '../components/curList'

export default {
  name: 'teacherDetail',
  components: {
    curList
  },
  data () {
    return {
      teacherId: '',
      teacherData: {}
    }
  },
  mounted () {
    this.teacherId = this.$route.query.teacherId
    this.getData(this.teacherId)
  },
  methods: {
    getData (id) {
      let that = this
      that.$http({
        method: 'get',
        url: '/api/renren-fast/app/olteacher/info/' + id
      }).then((result) => {
        if (result.data.code === 0) {
          that.teacherData = result.data.data
          that.teacherData.score = Number(result.data.data.score)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacherDetail{
  width: 1200px;
  margin: 0 auto;
  .teacherHead{
    /*background: #f4f9fd;*/
    border-bottom: 1px solid #d9d9d9;
    padding: 30px;
    .headBox{
      display: flex;
      .head-img{
        width: 150px;
        height: 150px;
        margin-right: 30px;
        border-radius: 50%;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .headContent{
        .nameBox{
          display: flex;
          margin-bottom: 15px;
          h3{
            margin-right: 30px;
          }
        }
        .blueColor{
          font-size: 24px;
          color: #00c5c3;
        }
        .synopsis{
          margin-top: 15px;
          color: #999999;
        }
      }
    }
  }
  .teacherContent{
    margin-top: 20px;
    .titleBox{
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/teacherDetail.vue